import { Icon, IMessageBarProps, MessageBar, MessageBarType } from "@fluentui/react";


interface IExampleProps {
    resetChoice?: () => void;
    bodyMenssaje: string;
}

/**Etiqueta Error */
export const TagError = (p: IExampleProps) => (
    <MessageBar
        messageBarType={MessageBarType.error}
        isMultiline
        onDismiss={p.resetChoice}
    >
        {p.bodyMenssaje}
    </MessageBar>
);

/**Etiqueta envio conforme */
export const TagSuccess = (p: IExampleProps) => (
    <MessageBar
        onDismiss={p.resetChoice}
        messageBarType={MessageBarType.success}
        isMultiline={false}
        dismissButtonAriaLabel="Close"
    >
        {p.bodyMenssaje}
    </MessageBar>
);

/**Etiqueta de advertencia*/
export const TagWarning = (p: IExampleProps) => (
    <MessageBar
        messageBarType={MessageBarType.warning}
        isMultiline={false}
        onDismiss={p.resetChoice}
        dismissButtonAriaLabel="Close"
    //   actions={
    //     <div>
    //       <MessageBarButton>Action</MessageBarButton>
    //     </div>
    //   }
    >
        {p.bodyMenssaje}
    </MessageBar>
);

/**Etiqueta de informacion*/
export const TagInfo = (p: IExampleProps) => (
    <MessageBar
        onDismiss={p.resetChoice}
        dismissButtonAriaLabel="Close"
        messageBarType={MessageBarType.warning}
        isMultiline
    >
        {p.bodyMenssaje}
    </MessageBar>
);

/**Etiqueta de default*/
export const TagDefault = (p: IExampleProps) => (
    <MessageBar
        onDismiss={p.resetChoice}
        dismissButtonAriaLabel="Close"
        isMultiline
    >
        {p.bodyMenssaje}
    </MessageBar>
);


/**ETIQUETA DETALLE*/
export const TagDetalle = ({ iconName = 'BookmarksMirrored', text = 'Detalle' }) => {
    return (
        <>
            <div className="ms-Grid-col ms-lg12" style={{ backgroundColor: '#dff6dd', padding: 5 }}>
                <Icon iconName={iconName} title={iconName} ariaLabel="arial-label" />
                <span>  </span>
                <span>{text}</span>
            </div>
        </>
    )
}